<template>
  <div class="">
    <b-col class="text-left">
      <router-link :to="{ name: 'Events' }">
        <b-button pill variant="purple" class="ml-1 mb-1"
        >
          رویدادها
        </b-button
        >
      </router-link>

    </b-col>

    <form>
      <form-group class="col-lg-6" :validations="$v.form.name">
        <div slot-scope="{ errors, invalid }">
          <label>نام</label>

          <input v-model="form.name" type="text" class="form-control">

          <form-errors-manager :errors="errors"/>
        </div>
      </form-group>
    </form>

  </div>
</template>


<script>
import FormErrorsManager from "../../validator/FormErrorsManager.vue";
import FormGroup from "../../validator/FormGroup.vue";
import {required} from "vuelidate/lib/validators";

export default {
  name: "CreateEvent",
  components: {FormGroup, FormErrorsManager},
  data() {
    return {
      form: {
        name: '',
        eventable_type: null,
        eventable_id: '',
        event: '',
      }
    }
  },
  validations: {
    form: {
      name: {required},
      eventable_type: {required},
      eventable_id: {required},
      event: {required},
    },
  },
}
</script>

<style scoped>

</style>